import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=879e0fec"
import script from "../../controllers/admin/admin-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/admin/admin-list.js?vue&type=script&lang=js&external"
import style0 from "./AdminList.vue?vue&type=style&index=0&id=879e0fec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports